import { parseAsArrayOf, parseAsString, useQueryState } from 'nuqs'
import { Text } from 'ui-kit/typography'
import classes from './IntegrationsError.module.scss'

export const IntegrationsError = ({
  searchValue,
  isIntegrations,
  isDataCollections,
  isOperations,
  isScenarios,
}: {
  searchValue?: string
  isIntegrations?: boolean
  isDataCollections?: boolean
  isOperations?: boolean
  isScenarios?: boolean
}) => {
  const [searchQuery] = useQueryState('search', parseAsString.withDefault(''))
  const [categoryQuery] = useQueryState(
    'category',
    parseAsString.withDefault(''),
  )
  const [filterQuery] = useQueryState(
    'filter',
    parseAsArrayOf(parseAsString, ',').withDefault([]),
  )

  const getResultType = () => {
    switch (true) {
      case isIntegrations:
        return 'integrations'
        break

      case isDataCollections:
        return 'data collections'
        break

      case isOperations:
        return 'operations'
        break

      case isScenarios:
        return 'scenarios'
        break

      default:
        return 'results'
        break
    }
  }

  const getFilterTypeResultString = (filter: string[]) => {
    if (filter.length === 0) return
    if (filter.length === 1) {
      return filter.includes('hasAuth') ? (
        <> that have authentication</>
      ) : (
        <> that have data collections</>
      )
    } else if (filter.length === 2)
      return <> that have authentication and data collections</>
    else return
  }

  return (
    <Text size={'lg'} className={classes.message}>
      <>Sorry, we couldn't find any {getResultType()}</>
      {(searchQuery || searchValue) && (
        <>
          {' '}
          matching your search query{' '}
          <Text as={'span'} size={'lg'} className={classes.text}>
            "{searchQuery || searchValue}"
          </Text>
        </>
      )}
      {categoryQuery && (
        <>
          {' '}
          in category <span className={classes.text}>"{categoryQuery}"</span>
        </>
      )}
      {getFilterTypeResultString(filterQuery)}.
    </Text>
  )
}
